import { TSection } from '@/shared/types/deprecated-types'

import { getCategoryParents } from './getCategoryParents'

/**
 * Returns the category and all its parents in the url-like format "/Mac/Macbook/Macbook Air"
 */
export const getCategoriesChain = (currentCategory: TSection, allCategories: TSection[]): string => {
	const categoryParents = getCategoryParents(allCategories, currentCategory)

	return categoryParents.map(({ title }) => title).join(`/`) + `/` + currentCategory.title
}
